import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Type is derived from the local constant; runtime data comes from the JSON file via HTTP.

@Injectable({ providedIn: 'root' })
export class PurchaseOrderFormConfigService {

  private readonly CONFIG_URL = 'assets/financial-hub/purchase-order-form.config.json';

  constructor(private readonly http: HttpClient) {}

  getConfig(): Observable<any> {
    // Swap CONFIG_URL for a real API endpoint when available:
    // private readonly CONFIG_URL = 'https://your-api/financial-hub/config/purchase-order-form';
    return this.http.get(this.CONFIG_URL);
  }
}
